/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';
import { Container, Row } from '../../../styles/Grid';
import {
  containerMarginCss,
  containerPaddingCss,
  columns2Css,
  textCss,
  titleCss,
} from './index.styles';
import { richTextCss } from '../../ui/richTextCss/index.styles';
import OffsetColumn from '../../ui/OffsetColumn';
import Spacer from '../../ui/Spacer';
import { fillEmptyValues } from '../../../utils/sitecore';
import { SafePureComponent } from '../../../utils/SafePureComponent';

export class TextBlock extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = fillEmptyValues(props.fields, {
      Text: '',
      Title: '',
      IsTwoColumns: false,
    });

    const columnsCss = get(fields, 'IsTwoColumns.value') ? columns2Css : {};

    return (
      <Spacer
        backgroundColor={fields.BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <OffsetColumn
              offsets={{ lg: 1, xl: 1 }}
              cols={{ sm: 6, md: 8, lg: 8 }}
            >
              <h2 css={titleCss}>
                <Text field={fields.Title} />
              </h2>
              <div css={textCss}>
                <RichText css={[columnsCss, richTextCss]} field={fields.Text} />
              </div>
            </OffsetColumn>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

TextBlock.displayName = 'TextBlock';

TextBlock.propTypes = {
  fields: PropTypes.shape({
    BackgroundColor: PropTypes.shape({
      fields: PropTypes.shape({
        Value: PropTypes.shape({
          value: PropTypes.string,
        }),
      }),
      id: PropTypes.string,
      url: PropTypes.string,
    }),
    IsTwoColumns: PropTypes.shape({
      value: PropTypes.bool,
    }),
    Text: PropTypes.shape({
      value: PropTypes.string,
    }),
    Title: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default TextBlock;
